import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import WhyRevelio from './components/WhyRevelio';
import CTA from './components/CTA';
import Footer from './components/Footer';
import DemoPage from './components/DemoPage';
import PostHogProvider from './components/PostHogProvider';
import PostHogIntegration from './components/PostHogIntegration';   // ← ADD THIS
import './styles/globals.css';

function HomePage() {
  return (
    <div className="flex flex-col min-h-screen bg-black">
      <Header />
      <main className="flex-grow">
        <Hero />
        <Features />
        <HowItWorks />
        <WhyRevelio />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <PostHogProvider>
        <div className="app overflow-hidden">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/posthog-integration" element={<PostHogIntegration />} />  {/* ← ADD THIS */}
          </Routes>
        </div>
      </PostHogProvider>
    </Router>
  );
}

export default App;